import React, { useMemo, useState, useCallback, useEffect } from 'react';

import Grid from '@bo-components/common/grid/Grid';

const GridTestPage = () => {
  const [showData, setShowData] = useState([]);
  const [data, setData] = useState([]);

  const getData = useCallback(() => {
    const count = 100000;
    const data = [];
    const company = ['Google', 'Apple', '삼성전자', 'LG전자', '한화', 'Microsoft', '현대', '현기차', 'SK', '롯데'];

    const country = ['미국', '일본', '한국', '영국', '캐나다', '중국', '프랑스', '브라질', '인도', '이탈리아'];

    for (let i = 0; i < count; i++) {
      data.push({
        sCompany: company[Math.floor(Math.random() * 10)],
        sCountry: country[Math.floor(Math.random() * 10)],
        sSaleQuantity: Math.floor(Math.random() * 100000),
        sSaleIncrease: Math.floor(Math.random() * 10000),
        sPrice: Math.floor(Math.random() * 10000000),
        sSatisfaction: Math.floor(Math.random() * (100 - 50 + 1) + 50),
      });
    }

    return data;
  }, []);

  useEffect(() => {
    setData(getData());
  }, [getData]);

  const options = useMemo(
    () => ({
      Cfg: {
        SearchMode: 0,
      },
      Def: {
        Col: {
          RelWidth: 1,
        },
        Row: {
          CanFormula: 1,
        },
      },
      LeftCols: [{ Header: 'No.', Name: 'SEQ', Type: 'Int', RelWidth: 0, Width: 80, Align: 'Center' }],
      Cols: [
        {
          Header: '회사',
          Name: 'sCompany',
          Type: 'Text',
          MinWidth: 150,
          Align: 'Center',
        },
        { Header: '판매 국가', Name: 'sCountry', MinWidth: 100, Type: 'Text', Align: 'Center' },
        { Header: '판매 수량', Name: 'sSaleQuantity', Type: 'Int', MinWidth: 100 },
        { Header: '판매 증가량', Name: 'sSaleIncrease', Type: 'Int', MinWidth: 100 },
        { Header: '가격', Name: 'sPrice', Type: 'Int', MinWidth: 150, Format: '#,##0원' },
        { Header: '만족도', Name: 'sSatisfaction', Type: 'Int', MinWidth: 100, Format: '#\\%' },
      ],
    }),
    []
  );

  const render = useCallback(() => {
    setShowData(data);
  }, [data]);

  return (
    <>
      <button onClick={render}>load</button>
      <Grid unPaged unLoaded options={options} data={showData} />
    </>
  );
};

export default GridTestPage;
